import { Tooltip } from '@/components/ui/Tooltip'
import { ATTENTION_COPY } from '@/lib/invoice-status-copy'
import { cn } from '@/lib/utils'

/**
 * Hoe lang een factuur al bij de klant ligt. Staat bewust naast de statuspill en
 * niet erin: het is een afgeleide van de verzenddatum, geen status.
 *
 * Verschijnt alleen voorbij de ingestelde grens. De grens zelf komt hier nooit
 * langs; de leeftijd zelf zegt meer, en het getal staat in de instellingen.
 */
export function OpenDurationBadge({
  daysOpen,
  needsAttention,
  className,
}: {
  daysOpen: number
  needsAttention: boolean
  className?: string
}) {
  if (!needsAttention) return null

  return (
    <Tooltip content={ATTENTION_COPY}>
      <span
        className={cn(
          'inline-flex cursor-help items-center gap-1 rounded-md bg-status-overdue/10 px-1.5 py-0.5 text-[11px] font-medium text-status-overdue',
          className,
        )}
      >
        <span className="num tabular-nums">{daysOpen}</span>
        dagen open
      </span>
    </Tooltip>
  )
}
